<template>
    <div class="resources-select">
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <login-layout v-if="!loading">
            <v-row no-gutters>
                <v-spacer></v-spacer>
                <gappt-menu class="ma-4" :user="user"></gappt-menu>
            </v-row>
            <div class="pa-6">
                <application-profile :application="application"></application-profile>
                <div v-if="Object.keys(userResources).length">
                    <v-row class="mt-8 title font-weight-light" justify="center">
                        {{ user.first_name || 'Hi' }}, please select an account
                    </v-row>
                    <resources-list :resources="userResources" :applicationID="application.id" :user="user"></resources-list>
                </div>
                <div v-else>
                    <v-row class="mt-8 title font-weight-light" justify="center">
                        You do not have eligible accounts.
                    </v-row>
                </div>
            </div>
        </login-layout>
    </div>
</template>

<script>
    import Vue from "vue";
    import ApplicationModel from "../models/application";
    import UserResourceModel from "../models/userResource";
    import User from "../models/user";
    import ApplicationProfile from "./ApplicationProfile";
    import ResourcesList from "./ResourcesList";
    import GapptMenu from "./Menu";

    export default {
        name: "ResourceSelect",
        components: { GapptMenu, ApplicationProfile, ResourcesList },
        data() {
            return {
                user: new User(),
                application: new ApplicationModel(),
                userResources: []
            };
        },

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$sessionGuard.check(to, from, next)
        },

        mounted() {
            this.getData()
        },

        methods: {
            async getData() {
                this.$store.commit('loadingOn')
                try {
                    await Promise.all([
                        this.getUser(),
                        this.getResources()
                    ]);
                } catch (e) {
                    if (this.$isDevEnviroment) {
                        console.log(e);
                    } else {
                        await this.$router.replace({ name: 'error' })
                    }
                }
                this.$store.commit('loadingOff')
            },

            async getUser() {
                let userResponse = await this.$sessionService.current();
                this.user = new User(userResponse.login)
            },

            async getResources() {
                try {
                    let application = await this.$ticketService.application()
                        .then(response => response);

                    this.application = new ApplicationModel(application);
                    this.setPageTitle(application.name);

                    let resourcesResponse = await this.$sessionService.resources(application.id);

                    this.userResources = resourcesResponse.resources.map(
                        item => new UserResourceModel(item)
                    )
                } catch (e) {
                    //
                }
            },

            setPageTitle(applicationName) {
                document.title = `${applicationName} | Select account`;
            }
        }
    }
</script>
